/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S1_HeadingInputs */

const tr_hakkimizda_s1_heading = /** @type {(inputs: Hakkimizda_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biz Kimiz`)
};

const en_hakkimizda_s1_heading = /** @type {(inputs: Hakkimizda_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who We Are`)
};

const de_hakkimizda_s1_heading = /** @type {(inputs: Hakkimizda_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer wir sind`)
};

const ru_hakkimizda_s1_heading = /** @type {(inputs: Hakkimizda_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кто мы`)
};

/**
* | output |
* | --- |
* | "Who We Are" |
*
* @param {Hakkimizda_S1_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s1_heading = /** @type {((inputs?: Hakkimizda_S1_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S1_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s1_heading(inputs)
	if (locale === "de") return de_hakkimizda_s1_heading(inputs)
	if (locale === "ru") return ru_hakkimizda_s1_heading(inputs)
	return tr_hakkimizda_s1_heading(inputs)
});